import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";

import Home from './Pages/Home';
import About from './Pages/About';
import Header from './Component/Header';

import Timetable from './Pages/admincu/Timetable';
import Listname from './Pages/admincu/Listname';
import Footter from './Component/Footter';
import Listname2 from './Pages/admincu/Listname2';
import Classroom from './Pages/admincu/Classroom';
import Teach from './Pages/admincu/Teach';
import Learn from './Pages/admincu/Learn';
import Searchroom from './Pages/admincu/Searchroom';
import Teachpay from './Pages/admincu/Teachpay';
import Reporttess from './Pages/admincu/Reporttess';
import Listname3 from './Pages/admincu/Listname3';
import Listname4 from './Pages/admincu/Listname4';
import Building from './Pages/admincu/Building';
import Reporttess2 from './Pages/admincu/Reporttess2';
import Buildingreport from './Pages/admincu/Buildingreport';
import Buildingreportlist from './Pages/admincu/Buildingreportlist';
import Timetabletype2 from './Pages/admincu/Timetabletype2';
import Reporttesscheckall from './Pages/admincu/Reporttesscheckall';
import Reporttesscheckall2 from './Pages/admincu/Reporttesscheckall2';
import Reporttesscheckall5 from './Pages/admincu/Reporttesscheckall5';
import Reporttesscheckall3 from './Pages/admincu/Reporttesscheckall3';
import Reporttesstotal from './Pages/admincu/Reporttesstotal';
import Timetablebygruop from './Pages/admincu/Timetablebygruop';
import Learn1 from './Pages/admincu/Learn1';
import Course from './Pages/admincu/Course';












export default class Routes extends Component {

    render() {
     //   console.log(this.props.location.pathname )
    // console.log(location.pathname);
    console.log(window.location.pathname);
        return (
            <>
    
    
   
            <Router basename="tess" >
            {/* <Switch>
            <Route exact path="/Timetable1" component={Timetable} />
            </Switch> */}
            {window.location.pathname === "/tess/Teach1" || window.location.pathname === "/tess/Learnst" || window.location.pathname === "/tess/Course" || window.location.pathname === "/tess/Searchroom1"  ?<></>:<>
            <Header />
            </>}
                
                {/* <br/> */}
                <div className="content-container" > 
               <Switch>
                  
                    <Route exact path="/" component={Home} />
                    <Route exact path="/Timetable" component={Timetable} />
                    <Route exact path="/Listname" component={Listname} />
                    <Route exact path="/Listname2" component={Listname2} />
                    <Route exact path="/Classroom" component={Classroom} />
                    <Route exact path="/Teach" component={Teach} />
                    <Route exact path="/Teach1" component={Teach} />
                    <Route exact path="/Learn" component={Learn} />
                     <Route exact path="/Learnst" component={Learn1} />
                    <Route exact path="/Searchroom" component={Searchroom} />
                    <Route exact path="/Searchroom1" component={Searchroom} />
                    <Route exact path="/Teachpay" component={Teachpay} />
                    <Route exact path="/Reporttess" component={Reporttess} />
                    <Route exact path="/Listname3" component={Listname3} />
                    <Route exact path="/Listname4" component={Listname4} />
                    <Route exact path="/Building" component={Building} />
                    <Route exact path="/Reporttess2" component={Reporttess2} />
                    <Route exact path="/Buildingreport" component={Buildingreport} />
                    <Route exact path="/Buildingreportlist/:id" component={Buildingreportlist} />
                    <Route exact path="/Timetabletype2" component={Timetabletype2} />
                    <Route exact path="/Reporttesscheckall" component={Reporttesscheckall} />
                    <Route exact path="/Reporttesscheckall2" component={Reporttesscheckall2} />
                    <Route exact path="/Reporttesscheckall5" component={Reporttesscheckall5} />
                    <Route exact path="/Reporttesscheckall3" component={Reporttesscheckall3} />
                    <Route exact path="/Reporttesstotal" component={Reporttesstotal} />
                    <Route exact path="/Timetablebygruop" component={Timetablebygruop} />
                    <Route exact path="/Course" component={Course} />
                    
                    <Route render={function () {return <h1>Not Found</h1> }} />
                </Switch>
                 {/* <br/> */}
</div>
               <footer className="footer--pin">
               {window.location.pathname === "/tess/Teach1" || window.location.pathname === "/tess/Learnst" || window.location.pathname === "/tess/Course" || window.location.pathname === "/tess/Searchroom1" ?<></>:<>
                <Footter />
            </>}
  {/* <Footter /> */}

</footer>
               
            </Router>
            
        
          </>  
        )
    }
}
